import dayjs from 'dayjs';
import {
  atmNoticeHTML,
  noticeOfPastDuePaymentHTML,
  overDraftNoticeHTML,
  overDraftPayAdvantageHTML,
  eStatementIsAvailableHTML,
  emailVerificationHTML,
  resetPasswordSecureTokenHTML,
  resetPasswordHTML,
  visaApplicationHTML,
} from './HTML';
import type { ITemplate } from '../../../../notifications';

const TEMPLATES: ITemplate[] = [
  {
    id: 3759,
    key: 'e-notification-template-1',
    subject: 'Notice of Past Due Payment',
    contentHTML: noticeOfPastDuePaymentHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3760,
    key: 'e-notification-template-2',
    subject: 'ATM Notice',
    contentHTML: atmNoticeHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3791,
    key: 'e-notification-template-3',
    subject: 'OverDraft Notice',
    contentHTML: overDraftNoticeHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3792,
    key: 'e-notification-template-4',
    subject: 'OverDraft Pay Advantage',
    contentHTML: overDraftPayAdvantageHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3793,
    key: 'e-notification-template-5',
    subject: 'eStatement Is Available',
    contentHTML: eStatementIsAvailableHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3794,
    key: 'e-notification-template-6',
    subject: 'Email Verification',
    contentHTML: emailVerificationHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3795,
    key: 'e-notification-template-7',
    subject: 'Reset Password Secure Token',
    contentHTML: resetPasswordSecureTokenHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3796,
    key: 'e-notification-template-8',
    subject: 'Reset Password',
    contentHTML: resetPasswordHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: 3797,
    key: 'e-notification-template-9',
    subject: 'Visa Application',
    contentHTML: visaApplicationHTML,
    time: dayjs().subtract(1, 'day').toISOString(),
  },
];

const initializeENotificationsTemplates = () => {
  TEMPLATES.forEach(template => {
    if (localStorage.getItem(template.key)) return;
    localStorage.setItem(template.key, JSON.stringify(template));
  });
};

export default initializeENotificationsTemplates;
